import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAccessLevel } from '../../hooks/useAccessLevel';
import { useWallet } from '../../context/WalletContext';

/**
 * Banner de acceso limitado
 * 
 * Se muestra cuando el usuario tiene acceso limitado (sin NFT).
 * Es persistente y no se puede cerrar, recordando constantemente
 * al usuario que debe completar su cuenta comprando un NFT.
 */
const LimitedAccessBanner = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { isConnected, address } = useWallet();
  const { isLimitedAccess, isLoading } = useAccessLevel();
  
  // Rutas donde NO debe mostrarse el banner
  const excludedRoutes = [
    '/register',
    '/nft/register',
    '/nft/select-nft-collection',
    '/nft/choose-character',
    '/nft/buy-pet',
    '/nft/pet-confirmation',
    '/login',
    '/page-register',
  ];
  
  const isExcludedRoute = excludedRoutes.some(route => 
    location.pathname.startsWith(route)
  );
  
  // No mostrar si:
  // - No está conectado
  // - No tiene acceso limitado
  // - Está cargando
  // - Está en una ruta excluida
  if (!isConnected || !address || !isLimitedAccess || isLoading || isExcludedRoute) {
    return null;
  }
  
  const handlePurchaseNFT = () => {
    navigate('/nft/select-nft-collection');
  };
  
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: '#ffffff',
        padding: '16px 24px',
        zIndex: 9999,
        boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        flexWrap: 'wrap',
      }}
    >
      <div style={{ flex: 1, minWidth: '200px' }}>
        <div
          style={{
            fontSize: '16px',
            fontWeight: '600',
            marginBottom: '4px',
          }}
        >
          {t('access.complete_account', 'Complete your account setup')}
        </div>
        <div
          style={{
            fontSize: '14px',
            opacity: 0.9,
          }}
        >
          {t(
            'access.purchase_nft_message',
            'Purchase a Premium USDC NFT ($30) to unlock full access to all features'
          )}
        </div>
      </div>
      
      <button
        onClick={handlePurchaseNFT}
        style={{
          background: '#ffffff',
          color: '#667eea',
          border: 'none',
          borderRadius: '8px',
          padding: '12px 24px',
          fontSize: '14px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          whiteSpace: 'nowrap',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#f0f0f0';
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#ffffff';
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.2)';
        }}
      >
        {t('access.purchase_nft', 'Purchase USDC NFT')} - $30
      </button>
    </div>
  );
};

export default LimitedAccessBanner;
